import { useQuery } from "@tanstack/react-query";
import { axios } from "../../libs/axios";
import type { ChartResponseDto, MetricKey } from "@reactive-resume/dto";
import type { AxiosResponse } from "axios";
import qs from "qs";

type MetricType = Partial<Record<MetricKey, any>>;

const fetchMetricsDashboard = async (
  metric: string[],
  period?: { from: Date | undefined; to?: Date },
) => {
  const response = await axios.get<MetricType, AxiosResponse<MetricType>>(
    "/analytics/metricDashboard",
    {
      params: {
        metric,
        from: period?.from,
        to: period?.to,
      },
      paramsSerializer: (params) => {
        const filterParams = qs.stringify(params);
        return filterParams;
      },
    },
  );

  return response.data;
};

const fetchDataForChart = async (
  groupBy: string,
  period?: { from: Date | undefined; to?: Date },
) => {
  const response = await axios.get<ChartResponseDto, AxiosResponse<ChartResponseDto>>(
    "/analytics/chartDashboard",
    {
      params: {
        groupBy,
        from: period?.from?.toISOString(),
        to: period?.to?.toISOString(),
      },
      paramsSerializer: (params) => {
        const filterParams = qs.stringify(params);
        return filterParams;
      },
    },
  );

  return response.data;
};

export const useMetricDashboard = (
  metric: string[],
  period?: { from: Date | undefined; to?: Date },
) => {
  const { data, isPending, error } = useQuery({
    queryKey: ["metrics-dashboard", period],
    queryFn: () => fetchMetricsDashboard(metric, period),
    enabled: !!period,
  });

  return { data, isPending, error };
};

export const useChartDataDashboard = (
  groupBy: string,
  period?: { from: Date | undefined; to?: Date },
) => {
  const { data, isPending, error } = useQuery({
    queryKey: ["chartData", groupBy, period],
    queryFn: () => fetchDataForChart(groupBy, period),
    enabled: !!period,
  });

  return { data, isPending, error };
};
